// ** React Imports
import {
  Fragment, useEffect, useState
  // , useState, useEffect 
} from "react"
// ** Custom Components
import NavbarUser from "./NavbarUser"
import NavbarDropdown from "./NavbarDropdown"
// ** Third Party Components
import { Sun, Moon, Menu } from "react-feather"
import { useNavigate, useLocation } from "react-router-dom"
// ** Reactstrap Imports
import { NavItem, NavLink, Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap"
// import { isUserLoggedIn } from "@utils"
import {
  handleMenuCollapsed
} from "../../../../redux/layout"
import { displayMenu, getRefreshToken } from "../../../../views/redux/store"

// ** Config
import themeConfig from "../../../../configs/themeConfig"
// ** Store & Actions
import { useDispatch, useSelector } from "react-redux"
import GlobalVariable from "../../../../settings/global"
import useSessionTimeout from './useSessionTimeout'
const headerText = GlobalVariable.headerText

function ThemeNavbar(props) {
  const dispatch = useDispatch()
  const location = useLocation()
  // ** Props
  const { skin, setSkin, menuCollapsed
    // , setMenuVisibility 
  } = props
  const navigate = useNavigate()
  // const [titleName, setTitle] = useState('')
  // ** Function to toggle Theme (Light/Dark)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const stores = useSelector((state) => state.commonreducerSlice)
  //const [displayMenu, setDisplayMenu] = useState(false)
  const handleWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }
  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener("resize", handleWindowWidth)
    }

  }, [windowWidth])

  const ThemeToggler = () => {
    if (skin === "dark") {
      return <Sun className="ficon" onClick={() => setSkin("light")} />
    } else {
      return <Moon className="ficon" onClick={() => setSkin("dark")} />
    }
  }

  // useEffect(() => {
  //   if (isUserLoggedIn()) {
  //     if (JSON.parse(isUserLoggedIn()).isEmployee) {
  //       setTitle('Workorders')
  //     } else {
  //       setTitle('Dashboard')
  //     }
  //   }
  // }, [isUserLoggedIn()])
  const navigateMainPage = () => {
    sessionStorage.setItem('pageTransition', 'LR')
    navigate('/dashboard')
  }
  const trueBool = true

  async function displayFunction() {
    await dispatch(displayMenu(!stores?.displayMenuBool))
  }

  useEffect(() => {
    if (menuCollapsed) {
      document.documentElement.style.setProperty('--padding', '0 7rem 0 0.5rem')
    } else {
      document.documentElement.style.setProperty('--padding', '0 13rem 0 0.5rem')
    }
  }, [menuCollapsed])

  const [spinnerUStatus, setSpinnerStatus] = useState(true)
  const [sPopup, setSPopUp] = useState(false)
  const [tokenShow, setTokenShow] = useState(false)

  function formatTime(seconds) {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = Math.floor(seconds % 60)
    return { hours, minutes, seconds: secs }
  }

  async function refreshToken() {
    await dispatch(getRefreshToken())
    setSpinnerStatus(true)
    setSPopUp(false)
    setTokenShow(true)
    setTimeout(() => {
      setTokenShow(false)
    }, 5000)
  }

  const { showPopup, timeLeft } = useSessionTimeout(localStorage.getItem('token'), refreshToken, sPopup, tokenShow)
  const formattedTime = formatTime(timeLeft || 0)
  // const [spinnerUStatus, setSpinnerStatus] = useState(true)
  const updateYes = async () => {
    setSpinnerStatus(false)
    refreshToken()
  }

  useEffect(() => {
    setSPopUp(showPopup)
  }, [showPopup])

  return (
    <Fragment>
      <div className="bookmark-wrapper d-flex align-items-center">
        <div className="navbar-header d-flex" style={{ marginLeft: '0px', marginRight: '10px', height: location.pathname === '/dashboard' ? '57px' : '57px' }}>
          <ul className="nav navbar-nav nav-title">
            {windowWidth <= 1200 &&
              <NavItem className="mobile-menu me-auto">
                <NavLink
                  className={menuCollapsed ? "nav-menu-main menu-toggle  hidden-xs is-active" : "nav-menu-main menu-toggle hidden-xs is-active p-0"}
                  onClick={() => {
                    // setMenuVisibility(true)
                    dispatch(handleMenuCollapsed(menuCollapsed ? false : trueBool))
                  }}
                >
                  <Button
                    className="btn-icon btn_Action btn_Action_Icon toggle-icon m-0 addiconmenu"
                    color="secondary"
                    style={{ display: windowWidth <= 1200 ? "unset" : "none" }}
                    onClick={() => { displayFunction() }}
                  >
                    <Menu className="ficon" size={24} />
                  </Button>
                </NavLink>
              </NavItem>}
            <li className="nav-item dropdown_dashboard">
              <div className="portal_name">
                <div className={headerText ? location.pathname === '/dashboard' ? "portal_name_env_s" : 'portal_name_env_show' : "portal_name_env"} style={{ marginLeft: windowWidth <= 1200 ? '50px' : '15px' }}>Seafarer Portal</div>
                {headerText &&
                  <span className={location.pathname === '/dashboard' ? 'env_class_d' : "env_class"}>{headerText}</span>}
              </div>
              {location.pathname === '/dashboard' &&
                <NavbarDropdown />}
            </li>
          </ul>
          <NavbarUser skin={skin} setSkin={setSkin} />
        </div>
      </div>

      <div className='vertically-centered-modal'>
        <Modal scrollable className='modal-dialog-centered' isOpen={showPopup}>
          <ModalHeader>Session Time Out</ModalHeader>
          <ModalBody>
            <div className="p-1">
              <div className="popup">Your session will expire soon due to inactivity!</div>
              <p> Session expires in: <span className="text-danger">{formattedTime.minutes}m {formattedTime.seconds}s</span>. Do you want to continue session? </p>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className='model_popup_submit_btn'>
              {/* <Button color='secondary' onClick={() => updateNo()} className='me-1 reset_button_view'> No </Button> */}
              {spinnerUStatus ? (
                <Button color='secondary' onClick={() => updateYes()} className='create_submit_btn'> Yes </Button>
              ) : (
                <Button className='me-1' color='secondary' type='submit' disabled={!spinnerUStatus}>
                  <Spinner size='sm' />
                  <span className='mx-50'>Loading...</span>
                </Button>
              )}
            </div>
          </ModalFooter>
        </Modal>
      </div>

    </Fragment>
  )
}

export default ThemeNavbar
